import { Component, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogResult } from 'src/app/shared/dialogs/models';

export type DeleteCommentDialogData = {
  title?: string;
  description?: string;
};

@Component({
  templateUrl: './delete-comment-dialog.component.html',
  styleUrls: ['./delete-comment-dialog.component.scss'],
  standalone: false,
})
export class DeleteCommentDialogComponent {
  public title: string;
  public description: string;

  constructor(
    private dialogRef: MatDialogRef<DeleteCommentDialogComponent, DialogResult>,
    @Optional() @Inject(MAT_DIALOG_DATA) data?: DeleteCommentDialogData,
  ) {
    this.title = data?.title || 'Delete comment';
    this.description = data?.description || 'Are you sure you want to delete this comment?';
  }

  public close(): void {
    this.dialogRef.close({ done: false });
  }

  public done(): void {
    this.dialogRef.close({ done: true });
  }
}
